/**
 * Receives a date and returns a new date with neutral timezone.
 * @function
 * @name nullifyTimezone
 * @kind variable
 * @param {Date} date The date.
 * @returns {Date} Neutral timezone date.
 */
function nullifyTimezone(date: Date): Date {
  const offset = date.getTimezoneOffset() * 1000 * 60;
  return new Date(date.getTime() + offset);
}

/**
 * Receives a date and returns it formatted in dd/MM/yyyy.
 * @function
 * @name getFormatedDate
 * @kind function
 * @param {string} date The date.
 * @returns {string} A formated date (dd/MM/yyyy).
 * @exports
 */
export function getFormattedDate(date: string): string {
  const dateObj = new Date(date);
  if (dateObj.toString()?.toLowerCase() === "invalid date") {
    return date;
  }
  const neutralDate = nullifyTimezone(dateObj);
  const day = neutralDate.getDate();
  const month = neutralDate.getMonth() + 1;
  const year = neutralDate.getFullYear();
  return `${day < 10 ? "0" + day : day}/${
    month < 10 ? "0" + month : month
  }/${year}`;
}
